// extracted by mini-css-extract-plugin
export default {"select-equipment":"select-equipment_P5F8Kluf","loader-container":"loader-container_tjVWDXDb"};